import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
import { getTheme } from '../../theme';
import { DarkMode, LightMode, Logout, Person } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const HeaderContainer = styled.header`
  height: 70px;
  background-color: ${props => getTheme(props.theme?.isDark).colors.surfaceElevated};
  border-bottom: 1px solid ${props => getTheme(props.theme?.isDark).colors.border};
  position: fixed;
  top: 0;
  left: 260px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${props => getTheme(props.theme?.isDark).spacing.lg};
  z-index: 999;
  ${props => props.theme?.isDark && `
    box-shadow: 0 2px 10px ${getTheme(true).colors.glow};
  `}
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => getTheme(props.theme?.isDark).spacing.md};
`;

const IconButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: ${props => getTheme(props.theme?.isDark).borderRadius.md};
  border: 1px solid ${props => getTheme(props.theme?.isDark).colors.border};
  background-color: ${props => getTheme(props.theme?.isDark).colors.surface};
  color: ${props => getTheme(props.theme?.isDark).colors.text};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${props => getTheme(props.theme?.isDark).colors.hover};
    color: ${props => getTheme(props.theme?.isDark).colors.primary};
    ${props => props.theme?.isDark && `
      box-shadow: 0 0 10px rgba(0, 255, 0, 0.3);
    `}
  }
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => getTheme(props.theme?.isDark).spacing.sm};
  padding: ${props => getTheme(props.theme?.isDark).spacing.sm} ${props => getTheme(props.theme?.isDark).spacing.md};
  border-radius: ${props => getTheme(props.theme?.isDark).borderRadius.md};
  background-color: ${props => getTheme(props.theme?.isDark).colors.surface};
  border: 1px solid ${props => getTheme(props.theme?.isDark).colors.border};
`;

const UserName = styled.span`
  font-weight: 500;
  color: ${props => getTheme(props.theme?.isDark).colors.text};
`;

const Header = () => {
  const { isDark, toggleTheme } = useTheme();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const theme = { isDark };

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <HeaderContainer theme={theme}>
      <div></div>
      <HeaderRight>
        <IconButton onClick={toggleTheme} theme={theme}>
          {isDark ? <LightMode /> : <DarkMode />}
        </IconButton>
        {user && (
          <UserInfo theme={theme}>
            <Person />
            <UserName theme={theme}>{user.name || user.email}</UserName>
          </UserInfo>
        )}
        <IconButton onClick={handleLogout} theme={theme}>
          <Logout />
        </IconButton>
      </HeaderRight>
    </HeaderContainer>
  );
};

export default Header;

